import { useThirdPartyScriptsContext } from "@procore/third-party-scripts";

/**
 * Hook to access Bugsnag client from @procore/third-party-scripts.
 * Returns the bugsnag client if available, or null if not initialized.
 *
 * Usage:
 * ```tsx
 * const bugsnag = useBugsnag();
 * if (bugsnag) {
 *   bugsnag.notify(error);
 * }
 * ```
 */
export function useBugsnag() {
   const { scripts } = useThirdPartyScriptsContext();
   return scripts?.bugsnag?.client;
}
